import TrentialLogo from '@assets/branding/trential-with-text.svg';
import '@auth/custom/dynamic/ece-auth-styles.css';
import currentOrgConfig from '@config/current-org-config';
import theme from '@config/theme';
import { DATA_TEST_IDS } from '@data-test-ids';
import { Box, useMediaQuery } from '@mui/material';

interface OrgWithTrentialBrandingProps {
  size?: 'large' | 'small';
}

function OrgWithTrentialBranding({ size = 'small' }: OrgWithTrentialBrandingProps) {
  const smallerThanSMScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', columnGap: '10px' }}>
      <img
        src={TrentialLogo}
        style={{ height: 'auto', width: smallerThanSMScreen ? '80px' : '115px' }}
        alt="Trential Logo"
      />
      <Box
        sx={{
          height: {
            xs: size === 'large' ? '30px' : '22px',
            sm: size === 'large' ? '44px' : '22px'
          },
          width: '1px',
          backgroundColor: '#8F8F92'
        }}
      />
      <img
        src={new URL(`/src/wallet/${currentOrgConfig.LOGO.path}`, import.meta.url).href}
        style={{
          ...(currentOrgConfig?.LOGO?.css || {}),
          maxHeight: smallerThanSMScreen ? '2.5rem' : '3.35rem'
        }}
        alt={import.meta.env.VITE_ORG}
        data-test-id={DATA_TEST_IDS.ORG_LOGO_WITH_TRENTIAL}
      />
    </Box>
  );
}

export default OrgWithTrentialBranding;
